import { defineMeta } from '@/registry/types';

export const threatsExampleMeta = defineMeta({
  name: 'ThreatsExample',
  level: 'page',
  category: 'example',
  classification: 'custom',
  description: 'Reference threats page listing active attack paths by severity.',
  baseLibrary: 'custom',
  importPath: '@/pages/ThreatsExample',
  supportedStates: ['default'],
  designTokens: ['colors', 'severity', 'attackPath'],
  usageExamples: ['<ThreatsExample />'],
  llmSafe: false,
  whenToUse: ['Reference for threat/attack-path lists'],
  whenNotToUse: ['Production without data wiring'],
});

export default threatsExampleMeta;
